
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinamravati() {



const cardData = {
  keyword: 'Cab Service in Amravati MIDC Maharashtra',
  heading: 'eTravo: Cab Service in Amravati MIDC Maharashtra',
  headingDescription: `eTravo proudly delivers professional cab services in Amravati MIDC, Maharashtra, designed to support the transportation needs of manufacturing units, corporate offices, and industrial staff. Whether you require daily employee transfers, executive commutes, or client transportation, our services are tailored for reliability, safety, and efficiency. Our modern fleet includes air-conditioned, GPS-enabled vehicles driven by experienced, courteous chauffeurs who follow corporate travel standards. With customizable rental plans, real-time tracking, and round-the-clock support, eTravo ensures a seamless transportation experience across Amravati’s industrial zone. Trust eTravo for dependable cab solutions that keep your business moving smoothly.`,

  top: 'Top Places to visit in Amravati with eTravo',
     "topPlaces": [
    {
      "title": "Nandgaon Peth MIDC Industrial Area",
      "description": "Located just 4 km from Amravati city, the Nandgaon Peth MIDC Industrial Area spans over 178.95 hectares and hosts a variety of industries, including agro-processing units, textile manufacturing, and engineering firms. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Amravati City Center",
      "description": "The commercial and administrative heart of Amravati, featuring government offices, banks, and corporate establishments. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Amravati Railway Station",
      "description": "A crucial railway hub connecting Amravati with major cities across India. eTravo offers convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Amravati-Badnera Logistics Hub",
      "description": "An emerging logistics center enhancing the region's warehousing and transportation capabilities. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "Sant Gadge Baba Amravati University (SGBAU)",
      "description": "A premier educational institution attracting students and faculty from various regions. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "Hi-Tech Multispeciality Hospital & Research Center",
      "description": "A key healthcare facility in the region. eTravo provides dependable cab services for medical professionals, patients, and visitors, ensuring timely arrivals and departures for critical healthcare services."
    },
    {
      "title": "Tapadia City Centre Mall",
      "description": "A popular shopping destination in Amravati, offering a variety of retail outlets and entertainment options. eTravo facilitates transportation for shoppers and retail employees, enhancing the shopping experience with convenient and safe travel options."
    },
    {
      "title": "Hotel Grand Mehfil",
      "description": "A renowned hospitality establishment in Amravati. eTravo provides transportation solutions for hotel staff and guests, ensuring seamless travel experiences within the hospitality industry."
    },
    {
      "title": "Government College of Engineering, Amravati",
      "description": "An esteemed educational institution offering quality engineering education. eTravo provides transportation solutions for students and faculty members, ensuring safe and timely commutes."
    },
    {
      "title": "RIMS Hospital",
      "description": "A multi-specialty hospital serving the healthcare needs of Amravati residents. eTravo offers reliable cab services for healthcare professionals and patients, ensuring timely arrivals and departures from hospitals and clinics."
    }
  ],

services: [
  {
    name: 'Amravati MIDC Corporate Cab Rentals',
    description: `Customized corporate cab rental plans designed to meet the diverse needs of businesses operating in Amravati MIDC. Whether for daily commutes, corporate events, or long-term contracts, our fleet is maintained to high standards and bookings are hassle-free to support your business logistics seamlessly.`
  },
  {
    name: 'Employee Transport Cab Amravati MIDC',
    description: `Dependable employee transport services synchronized with factory and office shift schedules. Our GPS-enabled cabs and professional drivers ensure safe, timely, and comfortable daily commutes, enhancing productivity by ensuring your workforce travels without delays.`
  },
  {
    name: 'Business Cab Services Amravati MIDC',
    description: `Flexible cab services catering to business executives and staff traveling for meetings, client visits, and site inspections. Drivers with local route expertise provide efficient and comfortable travel experiences within Amravati and nearby areas.`
  },
  {
    name: 'Corporate Staff Cabs Amravati MIDC',
    description: `Group transportation solutions featuring multi-route planning and GPS tracking for corporate teams commuting together. This service offers cost savings, reduced congestion, and enhanced safety through coordinated batch pickups and drop-offs.`
  },
  {
    name: 'Reliable Corporate Cab Service Amravati MIDC',
    description: `Consistently high-quality service with clean, well-maintained vehicles and professional drivers. We focus on punctuality, courteous service, and clear communication to meet the specific needs of corporate clients in Amravati MIDC.`
  },
  {
    name: 'AC Corporate Cabs Amravati MIDC',
    description: `Air-conditioned corporate cabs providing a comfortable and pleasant travel experience regardless of Amravati’s weather conditions. Perfect for daily commuting and executive transportation, our AC fleet ensures a cool, relaxing journey even in summer months.`
  },
  {
    name: 'Staff Pickup and Drop Cab Amravati MIDC',
    description: `Comprehensive staff transportation supporting multiple shifts, including night duties. With flexible scheduling and 24/7 availability, our experienced drivers guarantee safe and punctual pickups and drop-offs for your workforce round the clock.`
  },
  {
    name: 'Affordable Business Cab Rentals Amravati MIDC',
    description: `Cost-effective cab rental options designed for small, medium, and large businesses. Transparent pricing and scalable vehicle plans enable companies to optimize transport budgets while maintaining reliability and service quality.`
  },
  {
    name: 'Executive Cab Services Amravati MIDC',
    description: `Premium executive transportation with luxury vehicles and skilled chauffeurs. Ideal for airport transfers, VIP client visits, and high-profile meetings, ensuring a discreet, comfortable, and professional travel experience for senior management.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Amravati MIDC',
    description: `Fixed-route monthly plans simplifying employee transport management, reducing administrative tasks, and ensuring consistent, high-quality service. Easy billing and close coordination with HR and admin teams help streamline corporate logistics.`
  },
  {
    name: 'Industrial Area Employee Transport Amravati MIDC',
    description: `Specialized transport for industrial workers, focusing on safety, punctuality, and compliance with regulations. Our optimized routing ensures smooth, timely travel between residential areas and factories within Amravati MIDC.`
  },
  {
    name: 'Corporate Client Cabs Amravati MIDC',
    description: `Dedicated client transportation services providing a professional, comfortable, and punctual experience for visiting business guests. From airport pickups to corporate site visits, we help you maintain a strong business impression.`
  },
  {
    name: 'Business Meeting Cabs Amravati MIDC',
    description: `Rapid response cab services designed for executives attending urgent or scheduled meetings within Amravati and surrounding areas. Easy booking, prompt dispatch, and professional drivers ensure seamless business travel.`
  },
  {
    name: 'Amravati Industrial Area Cab Hire',
    description: `Flexible on-demand cab hire services for site inspections, logistics, and errands across Amravati’s industrial zones. Drivers familiar with the industrial landscape provide efficient and hassle-free transportation.`
  },
  {
    name: 'Corporate Shuttle Cabs Amravati MIDC',
    description: `Group shuttle services using minibuses or large vans to transport employees during shift changes or corporate events. This service improves operational efficiency, reduces environmental impact, and ensures coordinated team travel.`
  }
],

tableData: [
  ['Amravati MIDC Corporate Cab Rentals', 'Employee Transport Cab Amravati MIDC'],
  ['Business Cab Services Amravati MIDC', 'Corporate Staff Cabs Amravati MIDC'],
  ['Reliable Corporate Cab Service Amravati MIDC', 'AC Corporate Cabs Amravati MIDC'],
  ['Staff Pickup and Drop Cab Amravati MIDC', 'Affordable Business Cab Rentals Amravati MIDC'],
  ['Executive Cab Services Amravati MIDC', 'Monthly Corporate Cab Rentals Amravati MIDC'],
  ['Industrial Area Employee Transport Amravati MIDC', 'Corporate Client Cabs Amravati MIDC'],
  ['Business Meeting Cabs Amravati MIDC', 'Amravati Industrial Area Cab Hire'],
  ['Corporate Shuttle Cabs Amravati MIDC', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Cab Services for Amravati MIDC",
    "WhyChoosedescription": "eTravo offers specialized cab services tailored for businesses operating in Amravati MIDC, a key industrial hub in Maharashtra. Our focus is on providing timely, safe, and comfortable transportation to enhance employee productivity and operational efficiency."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our fleet consists of sedans, SUVs, and multi-utility vehicles, allowing companies to select the most suitable vehicle for employee commutes, executive travel, or client visits, all maintained to ensure safety and comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Expertise",
    "WhyChoosedescription": "Our drivers are professionally trained with in-depth knowledge of Amravati MIDC’s road network and industrial layout, ensuring efficient routes, punctual pickups, and a smooth travel experience."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "Understanding the diverse shift schedules in industrial sectors, we provide flexible booking solutions including scheduled rides, on-demand services, and long-term contracts to suit your business needs."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All our vehicles are equipped with GPS tracking, enabling real-time ride monitoring. This improves safety, driver accountability, and provides transparency for corporate clients."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We provide clear, itemized billing statements with trip details and fare breakdowns, facilitating smooth financial management and reimbursements."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "Our fleet is regularly sanitized and maintained, and drivers adhere to strict hygiene protocols to ensure a safe and healthy travel environment."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager to manage bookings, address queries promptly, and ensure a hassle-free transportation experience in Amravati MIDC."
  }
]








}

const faqData = [
  [
    {
      question: "Which areas do your Amravati MIDC cab services cover?",
      answer: "Our services cover the entire Amravati MIDC area as well as nearby industrial and business zones to support seamless corporate transportation."
    },
    {
      question: "Can we schedule cabs for multiple employee shifts?",
      answer: "Yes, we offer scheduling for fixed and rotating shifts, ensuring timely transport for all your workforce needs."
    },
    {
      question: "Do you provide monthly billing for corporate clients?",
      answer: "Yes, we provide GST-compliant monthly invoices with detailed trip logs for transparent and hassle-free billing."
    },
    {
      question: "Are your drivers trained in professional conduct?",
      answer: "Absolutely. Our drivers undergo training in safety, punctuality, and professional etiquette tailored for corporate clients."
    },
    {
      question: "What measures do you take to ensure passenger safety?",
      answer: "We prioritize safety with real-time GPS tracking, vehicle sanitization, background-verified drivers, and emergency support features."
    },
    {
      question: "Is there dedicated support for business clients?",
      answer: "Yes, corporate customers receive account-specific support through dedicated managers and a priority service helpline."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Ramesh More",
    designation: "Operations Head, Amravati Auto Parts Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo has been a game-changer for our transport management. Their punctuality and professionalism are truly commendable.”"
  },
  {
    name: "Ms. Shweta Kale",
    designation: "HR Manager, Amravati AgroTech Pvt. Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“We've seen improved employee satisfaction thanks to eTravo’s reliable cab services. Highly recommended for any industrial operation.”"
  }
];








































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Amravati MIDC Maharashtra",
  "image": "https://www.etravo.in/images/keyword/cab-service-amravati-midc.jpg",
  "description": "Reliable corporate cab service in Amravati MIDC Maharashtra offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-amravati-midc"
  }
};





    return (
        <div>
<Helmet>
  <title>Cab Service in Amravati MIDC Maharashtra | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Amravati MIDC Maharashtra for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/88.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinamravati;